<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>反馈管理</el-breadcrumb-item>
        <el-breadcrumb-item>金点子列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <hx-table-result :loading="tableLoading">
      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button type="primary" @click="loadTableData">刷新</el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ tableData.length }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" border>
        <el-table-column prop="createDate" align="center" label="创建时间" width="240">
          <template v-slot="scope">{{ scope.row.createDate | formatDate }}</template>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="手机号" width="200" />
        <el-table-column prop="content" align="left" label="金点子内容" />
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      listParams: {},
      tableLoading: false,
      tableData: [],
    };
  },
  mounted() {
    this.loadTableData();
  },

  filters: {
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },

  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/golden/idea/list",
        method: "GET",
      })
        .then(res => {
          const result = res.body || {};
          if (result.apiStatus === 0 && result.sysStatus === 0) {
            this.tableLoading = false;
            if (result.data) {
              this.tableData = result.data || [];
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
            this.$message({ message: res.body.info, type: "error" });
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
